module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page_6"
  }, [_c('div', {
    staticClass: "panel",
    style: ({
      backgroundImage: 'url(' + _vm.imgBg + ')'
    })
  }, [_c('h1', [_vm._v("马上预约一次现场演示")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogMap = true
      }
    }
  }, [_vm._v("查看地图位置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogInfo = true
      }
    }
  }, [_vm._v("获取DEMO")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('foot'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "show-close": false,
      "modal-append-to-body": false,
      "size": "small"
    },
    model: {
      value: (_vm.dialogInfo),
      callback: function($$v) {
        _vm.dialogInfo = $$v
      },
      expression: "dialogInfo"
    }
  }, [_c('div', [_c('h3', [_vm._v("获取DEMO"), _c('small', [_vm._v("想要预约一次现场演示，领取DEMO，请填写表格")])]), _vm._v(" "), _c('el-form', {
    ref: "formData",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.formData.name = $$v
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.formData.phone = $$v
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "company",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.formData.company),
      callback: function($$v) {
        _vm.formData.company = $$v
      },
      expression: "formData.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "需求",
      "prop": "demand",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "需求"
    },
    model: {
      value: (_vm.formData.demand),
      callback: function($$v) {
        _vm.formData.demand = $$v
      },
      expression: "formData.demand"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogInfo = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "large",
      "show-close": false,
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogMap),
      callback: function($$v) {
        _vm.dialogMap = $$v
      },
      expression: "dialogMap"
    }
  }, [_c('BMap')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('label', [_vm._v("我们在这里")]), _vm._v("\n\t\t厦门市湖里区园山南路806号\n\t\t"), _c('span', [_vm._v("|")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-youxiang"
  }), _vm._v("qlink@qlink.cc\t\t\t\n\t\t"), _c('span', [_vm._v("|")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-shouji"
  }), _vm._v("0592-8222272\n\t\t"), _c('i', {
    staticClass: "iconfont icon-weihu"
  }), _vm._v("终身故障维护\n\t\t"), _c('i', {
    staticClass: "iconfont icon-liaotian"
  }), _vm._v("7×24小时售后支持\n\t\t"), _c('i', {
    staticClass: "iconfont icon-mian"
  }), _vm._v("软件永久免费\n\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3de8206f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/page_6.vue
// module id = 778
// module chunks = 1